import { defaultVariantColorsResolver, parseThemeColor, type VariantColorsResolver } from "@mantine/core";

export const invertedFilledVariantResolver: VariantColorsResolver = (input) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input);
  const parsedColor = parseThemeColor({
    color: input.color || input.theme.primaryColor,
    theme: input.theme,
  });

  if (parsedColor.isThemeColor && input.variant === "inverted-filled") {
    const filledColors = defaultVariantColorsResolver({
      ...input,
      variant: "filled",
    });

    return {
      ...filledColors,
      background: filledColors.color,
      color: filledColors.background,
      hover: filledColors.hoverColor || filledColors.color,
      hoverColor: filledColors.hover || filledColors.background,
    };
  }

  return defaultResolvedColors;
};
